module.exports = __webpack_public_path__ + "assets/bffb1f58fc8a1a1b441cc8d77154e5a8.js";